import _ from 'lodash';

import {
	SET_PURCHASE_LOADING,
	SET_PURCHASE_SUCCESS,
	SET_PURCHASE_FAIL,
	CLEAR_PURCHASES,
} from '../constants';

import { setPetToCollected } from './allPets';
import { getNewGoodyOnPurchase } from './collectedGoodies';
import log from '../utils/log';


export function setPurchaseLoading(sku, isLoading) {
	return {
		type: SET_PURCHASE_LOADING,
		payload: {
			sku,
			isLoading,
		},
	};
}

export function setPurchaseSuccess(sku) {
	return {
		type: SET_PURCHASE_SUCCESS,
		payload: {
			sku,
		},
	};
}

export function setPurchaseFail(sku) {
	return {
		type: SET_PURCHASE_FAIL,
		payload: {
			sku,
		},
	};
}

export function clearPurchases() {
	return {
		type: CLEAR_PURCHASES,
	};
}

export function onPurchase(sku, buyResponse, dispatch, { forceSuccess } = {}) {
	const successResponse = !!_.get(buyResponse, 'checkoutOrderId') || !!_.get(buyResponse, 'response.orderId') || !!_.get(buyResponse, 'orderId');
	const errorResponse = !!_.get(buyResponse, 'response.errorType');
	const purchaseWasSuccessful = successResponse && !errorResponse;

	log('actions -> onPurchase -> successResponse: ', successResponse);
	log('actions -> onPurchase -> errorResponse: ', errorResponse);
	log('actions -> onPurchase -> purchaseWasSuccessful: ', purchaseWasSuccessful);

	if (purchaseWasSuccessful || forceSuccess) {
		dispatch(setPurchaseSuccess(sku));
		dispatch(setPetToCollected(sku, true));
		dispatch(getNewGoodyOnPurchase(sku));
	} else {
		dispatch(setPurchaseFail(sku));
	}
}

export function checkForSkuPurchase(sku, purchasesResponse) {
	const purchases = _.get(purchasesResponse, 'response.details');
	const skuWasPurchased = !!_.find(purchases, { sku, state: 'ACTIVE' });

	return skuWasPurchased;
}

// # User clicks buy
// - push this pet to `purchases` { sku: { isLoading: true } }
// - API.buy(sku) _returns order_id or error_
// 	- *then* API.getPurchases() _returns list of all purchases_
// 		- *then* (response) => filter by sku, find the latest one.
// 			- If state = ACTIVE:
// 				- push this pet to `collectedPets` _saved_
// 				- push this pet to `purchases` -> { sku: { isLoading: false, success: true } } _not saved_
// 			- If state != ACTIVE:
// 				- push this pet to `purchases` -> { sku: { isLoading: false, error: true, errorState: <state> } } _not saved_
//
// # SUCCESS: User gets pet
// Add success class to pet, but keep it in the list of un-purchased items so that
// it doesn't re-render. Replace "buy" callback with "setActive" one.
//
// _pet LIST should store `collectedPets` only once on componentDidMount._
// _pet ITEM needs to compare `purchases` to each item, as it does with `activePet`,
// to apply and remove classes accordingly._
//
// # FAIL: User sees error
// Add error element to PetItem
//
// # User closes PetPicker
// Set `purchases` to empty.



// WEBPACK FOOTER //
// ./src/actions/purchases.js